import { render, staticRenderFns } from "./DefaultSalesforceSyncButton.vue?vue&type=template&id=98710f9e&"
import script from "./DefaultSalesforceSyncButton.vue?vue&type=script&lang=js&"
export * from "./DefaultSalesforceSyncButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports